import React from 'react';
import Hero from '../../components/Hero/Hero';
import Features from '../../components/Features/Features';
import About from '../../components/About/About';
import './Home.scss';

const Home: React.FC = () => {
  return (
    <div className="home">
      <Hero />
      <Features />
      <About />
    </div>
  );
};

export default Home;
